import React, { Component } from 'react';
import { forwardRef } from 'react';

import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import highchartsMore from "highcharts/highcharts-more.js";
import xRange from "highcharts/modules/xrange.js";

// Material components
import styles from './styles';

import Badge from '@material-ui/core/Badge';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import compose from 'recompose/compose';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Grid } from '@material-ui/core';
import moment from 'moment'
import 'moment/locale/es'  
moment.locale('es')



highchartsMore(Highcharts);
xRange(Highcharts);


Highcharts.setOptions ({
    lang: {
        months: [
            'Enero', 'Febrero', 'Marzo', 'Abril',
            'Mayo', 'Junio', 'Julio', 'Agosto',
            'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ],
        shortMonths: [
            'Ene', 'Feb', 'Mar', 'Abr',
            'Mar', 'Jun', 'Jul', 'Ag',
            'Sep', 'Oct', 'Nov', 'Dic'
        ],
        weekdays: [
            'Domingo', 'Lunes', 'Martes', 'Miercoles',
            'Jueves', 'Viernes', 'Sabado'
        ],
        shortWeekdays: ['D','L' ,'M', 'Mi', 'J', 'V', 'S']
    }
}) 

class AvailabilityConsolidated extends Component {

    constructor(props) {
        super(props)
    
        //console.log('props',props)
        //console.log(groups)
        this.state = {
            isLoading:true,
            contSteps:0,
            dataGroup:this.props.objs,
            chartOptionsStackedBarConsolidated: {},
        }
    }
    componentDidMount() {
        this.processData();
    }


    processData=()=>{
        const {dataGroup}=this.state
        var listDates=[]
        console.log("dataGroup", dataGroup)
        dataGroup.map(obj=>{
            /* console.log(obj.id, obj.nombre) */
            var filterObj=(Object.keys(obj.data).filter(i=>i!=='obj').map(i=>obj.data[i]))
            filterObj.map(ele=>{
                //console.log(ele.data)
                if(ele.data.length!==0){
                    ele.data.map(data=>{
                        //console.log(data)
                        listDates.push(data)
                    })
                }
            })
        })
        listDates.sort(function (a, b) {
            return (a.x - b.x);
        });
        //console.log(listDates)
        //console.log(listDates[0].x)
        //console.log(listDates[listDates.length-1].x2)
        console.log(listDates)
        //console.log(listDates.length-1)
        var dateStartCompare=listDates[0].x
        var dateEnd=listDates[listDates.length-1].x2
        var dateStartFinal = listDates[0].x2
        var lenObj=2
        var lenDates=2
        var listState=[]
        while(dateStartCompare < dateEnd){
            //console.log('tamaño de eventos',lenDates)
            if(lenDates!==lenObj){
                lenObj=lenDates
            }
            var begin=0
            var final=0
            var countDowntime = 0
            var countMonitoreo = 0
            var countCliente = 0
            var countParcial=0
            var countUp=0
            for (var i = 0; i < lenDates; i++){
                //console.log(i)
                //console.log(listDates[i].x, listDates[i].x2)
                begin=listDates[i].x
                final=listDates[i].x2
                //console.log(begin, final, dateStartCompare)
                if(final> dateStartCompare){
                    //console.log(listDates[i].color)
                    if(listDates[i].color == '#C2272D'){
                        countDowntime = countDowntime + 1
                    }else if(listDates[i].color == "#FFC600"){
                        countParcial = countParcial + 1
                    }else if(listDates[i].color == "#A9A9A9"){
                        countMonitoreo = countMonitoreo + 1
                    }else if(listDates[i].color == "blue"){
                        countCliente = countCliente + 1
                    }else{
                        countUp+=1
                    }
                }
                if(lenDates===lenObj){
                    lenDates+=1
                }
            }

            //console.log(dateStartCompare, final)
            
            var eventId='Operativo (verificado desde todos los ISP)'
            var color='#41B900'
            if(countParcial>0||countDowntime>0){
                //console.log(countDowntime, countParcial, countMonitoreo, countUp, 'isp con problema')
                eventId="Operativo (algunos ISP con problemas)"
                color='#FFC600'
            }
            if(countMonitoreo>0 && countParcial===0 && countDowntime===0&&countUp===0){
                //console.log(countDowntime, countParcial, countMonitoreo, countUp, 'sin')
                eventId="Sin Monitoreo o Periodo actual"
                color="#A9A9A9"
            }

            // ddiaz mod 26-05-2021
            //console.log(eventId)
            
            listState.push({'name':eventId,'pointWidth': 40, 'data':[{'x': dateStartCompare, 'x2': final, 'y': 0, 'color': color}]})
            
            dateStartCompare=final
            
        }

        //console.log('obj', listState)

        this.setState({ 
            
            isLoading:false,
            chartOptionsStackedBarConsolidated: {

                chart: {
                    type: 'xrange',
                    height: 90,
                },
                title: {
                    text: null
                },
                
                xAxis: {
                    type: 'datetime',
                    gridLineWidth: 0,
                    labels: {
                        enabled: false
                    },
                    visible: false
                },
                pane: {
                    size: '150%',
                },
                yAxis: {
                    categories: ['consolidado'],
                    title: {
                        text: ''
                    },
                    gridLineWidth: 0,
                    reversed: true,
                    labels: {
                        useHTML:true,//set to true
                        style:{
                            width:'100px',
                            whiteSpace:'normal'//set to normal
                        },
                        step: 1,
                        formatter: function () {//use formatter
                            return '<div align="center" style="word-wrap: break-word;word-break: break-all;width:100px">' + this.value + '</div>';
                        }
                    },
                    
                },
                series: listState,
                /*series:[{'name':'Uptime','pointWidth': 40, 'data':[{x: 1598264692000, x2: 1598274434000, y: 0, color: "#41B900"}
                , {x: 1598275034000, x2: 1598300459000, y: 0, color: "#41B900"}
                , {x: 1598301106000, x2: 1598302860000, y: 0, color: "#41B900"}
                , {x: 1598303463000, x2: 1598305260000, y: 0, color: "#41B900"}
                , {x: 1598305871000, x2: 1598306235000, y: 0, color: "#41B900"}
                , {x: 1598307135000, x2: 1598307660000, y: 0, color: "#41B900"}
                , {x: 1598308262000, x2: 1598309460000, y: 0, color: "#41B900"}
                , {x: 1598310662000, x2: 1598312461000, y: 0, color: "#41B900"}
                , {x: 1598317023000, x2: 1598326863000, y: 0, color: "#41B900"}
                , {x: 1598327729000, x2: 1598329263000, y: 0, color: "#41B900"}
                , {x: 1598329864000, x2: 1598331663000, y: 0, color: "#41B900"}
                , {x: 1598332265000, x2: 1598334063000, y: 0, color: "#41B900"}
                , {x: 1598334665000, x2: 1598336464000, y: 0, color: "#41B900"}
                , {x: 1598337065000, x2: 1598338864000, y: 0, color: "#41B900"}
                , {x: 1598339471000, x2: 1598341264000, y: 0, color: "#41B900"}
                , {x: 1598341866000, x2: 1598343663000, y: 0, color: "#41B900"}
                , {x: 1598344270000, x2: 1598346063000, y: 0, color: "#41B900"}
                , {x: 1598346671000, x2: 1598348463000, y: 0, color: "#41B900"}
                , {x: 1598349065000, x2: 1598350744000, y: 0, color: "#41B900"}]},{'name':'Downtime','pointWidth': 40, 'data':[]},{'name':'Downtime Parcial','pointWidth': 40, 'data':[]},
                {'name':'Downtime Parcial2','pointWidth': 40, 'data':[]},{'name':'No Monitoreo','pointWidth': 40, 'data':[]}],*/
               
                plotOptions: {
                    series: {
                        //borderRadius: 5,
                        pointWidth: 10,
                        turboThreshold: 0,
                        grouping: false
                    }
                },
                credits: {
                    enabled: false
                },
                tooltip: {
                    xDateFormat: '%A, %b %e, %Y %H:%M:%S',
                    enabled: true,
                },
                
                legend: {
                    enabled: false
                },
                
            },
        })
    }
    

    render() {
        const {isLoading, chartOptionsStackedBarConsolidated}=this.state
        //console.log(stepsStatus)
        //console.log(element)
        const {classes}=this.props
        if (isLoading===true) {
            return(
                    <Grid item lg={12} xl={12}>
                        <Typography
                        className={classes.circular}
                            variant="caption"
                            >
                            <CircularProgress
                            className={classes.circular}
                            variant="indeterminate"
                            size={8}
                            thickness={1}
                            
                            />
                            Cargando Grupos...
                        </Typography>
                    </Grid>
            )
        }else{
            //console.log('render', chartOptionsStackedBarConsolidated)
            return(
                    <Grid item lg={12} xl={12} >
                        {/*<Typography>jkh</Typography>*/}
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={chartOptionsStackedBarConsolidated} 
                        />
                    </Grid>
                
            )
        }
   
    }
}
export default
    compose(withStyles(styles))(AvailabilityConsolidated);